/**
 * 获取 ARMS Trace 实例
 */
export function getConeArmsTrace() {
    return window.coneArmsTrace;
}
